import React from 'react';

function RawBar() {
    return (
        <div class="menuList">
            <div className="wing-container">
        <div className="col">Raw Oysters per piece</div> <div className="dots"></div>{" "}
        <div className="col">$2.50</div>
      </div>
      <div className="wing-container">
        <div className="col">Clams Dozen</div> <div className="dots"></div>{" "}
        <div className="col">Market Price</div>
      </div>
      <div className="wing-container">
        <div className="col">Blackened Tuna Tenders</div> <div className="dots"></div>{" "}
        <div className="col">$12.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Seared Tuna (6oz)</div> <div className="dots"></div>{" "}
        <div className="col">$14.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Steam Mussels (Hot & Sweet)</div> <div className="dots"></div>{" "}
        <div className="col">Market Price</div>
      </div>
      <div className="wing-container">
        <div className="col">Steamed Shrimp (1/2 lb)</div> <div className="dots"></div>{" "}
        <div className="col">$10.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Steamed Garlic Shrimp</div> <div className="dots"></div>{" "}
        <div className="col">$11.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Steamed Banging Clams</div> <div className="dots"></div>{" "}
        <div className="col">$13.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Steamed Drunken Clams</div> <div className="dots"></div>{" "}
        <div className="col">$13.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Steamer Dozen</div> <div className="dots"></div>{" "}
        <div className="col">$10.99</div>
      </div>
        </div>
    )
}

export default RawBar